module.exports = __webpack_public_path__ + "static/famr-5d0030a4a8789652d4f4290d8aeddc58.jpg";